"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _DragManager_eventEngine, _DragManager_uuidGenerator, _DragManager_dragConstraints, _DragManager_effectMaterialToken, _DragManager_filter, _DragManager_intersection, _DragManager_node, _DragManager_setupOptions, _DragManager_tokenCameraFreeze, _DragManager_tokenContinuousRendering, _DragManager_tokenContinuousShadowMapUpdate;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragManager = void 0;
const gl_matrix_1 = require("gl-matrix");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const IInteractionEngine_1 = require("../../interfaces/IInteractionEngine");
const AbstractInteractionManager_1 = require("../AbstractInteractionManager");
const InteractionData_1 = require("../InteractionData");
const tsyringe_1 = require("tsyringe");
class DragManager extends AbstractInteractionManager_1.AbstractInteractionManager {
    constructor() {
        // #region Properties (11)
        super(...arguments);
        _DragManager_eventEngine.set(this, tsyringe_1.container.resolve(viewer_shared_services_1.EventEngine));
        _DragManager_uuidGenerator.set(this, tsyringe_1.container.resolve(viewer_shared_services_1.UuidGenerator));
        _DragManager_dragConstraints.set(this, {});
        _DragManager_effectMaterialToken.set(this, void 0);
        _DragManager_filter.set(this, (interactionState) => {
            if (interactionState === IInteractionEngine_1.INTERACTION_STATE.DOWN) {
                return (node) => {
                    for (let i = 0; i < node.data.length; i++) {
                        if (node.data[i] instanceof InteractionData_1.InteractionData) {
                            if (node.data[i].interactionTypes['drag'])
                                return true;
                        }
                    }
                    return false;
                };
            }
            return (node) => false;
        });
        _DragManager_intersection.set(this, null);
        _DragManager_node.set(this, null);
        _DragManager_setupOptions.set(this, null);
        _DragManager_tokenCameraFreeze.set(this, void 0);
        _DragManager_tokenContinuousRendering.set(this, void 0);
        _DragManager_tokenContinuousShadowMapUpdate.set(this, void 0);
        // #endregion Private Methods (4)
    }
    // #endregion Properties (11)
    // #region Public Accessors (1)
    get filter() {
        return __classPrivateFieldGet(this, _DragManager_filter, "f");
    }
    // #endregion Public Accessors (1)
    // #region Public Methods (7)
    addDragConstraint(constraint) {
        const token = __classPrivateFieldGet(this, _DragManager_uuidGenerator, "f").create();
        __classPrivateFieldGet(this, _DragManager_dragConstraints, "f")[token] = constraint;
        if (__classPrivateFieldGet(this, _DragManager_setupOptions, "f"))
            constraint.setup(__classPrivateFieldGet(this, _DragManager_setupOptions, "f").viewer, __classPrivateFieldGet(this, _DragManager_setupOptions, "f").node, __classPrivateFieldGet(this, _DragManager_setupOptions, "f").ray, __classPrivateFieldGet(this, _DragManager_setupOptions, "f").intersection);
        return token;
    }
    onDown(ray, intersection) {
        const intersections = intersection.filter(i => this.filter(IInteractionEngine_1.INTERACTION_STATE.DOWN)(i.node));
        if (intersections.length > 0)
            this.setNode(intersections[0].node, intersections[0].distance, intersections[0].point, ray);
    }
    onEnd(ray, intersection) {
        this.removeNode();
    }
    onMove(ray, intersection) {
        if (!__classPrivateFieldGet(this, _DragManager_node, "f"))
            return;
        const transformationMatrix = this.dragConstraintUtils.intersect(__classPrivateFieldGet(this, _DragManager_dragConstraints, "f"), this.viewer, __classPrivateFieldGet(this, _DragManager_node, "f"), ray);
        this.applyTransformation(__classPrivateFieldGet(this, _DragManager_node, "f"), transformationMatrix);
        this.viewer.updateNode(__classPrivateFieldGet(this, _DragManager_node, "f"));
        __classPrivateFieldGet(this, _DragManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE.INTERACTION.DRAG_MOVE, { node: __classPrivateFieldGet(this, _DragManager_node, "f"), matrix: transformationMatrix });
    }
    removeDragConstraint(token) {
        if (!__classPrivateFieldGet(this, _DragManager_dragConstraints, "f")[token])
            return false;
        delete __classPrivateFieldGet(this, _DragManager_dragConstraints, "f")[token];
        return true;
    }
    /**
     * Remove the node as the currently used drag node.
     *
     * @returns
     */
    removeNode() {
        var _a;
        if (!__classPrivateFieldGet(this, _DragManager_node, "f"))
            return;
        const transformationMatrix = (_a = __classPrivateFieldGet(this, _DragManager_node, "f").transformations.find(t => t.id === 'SD_drag_matrix')) === null || _a === void 0 ? void 0 : _a.matrix;
        __classPrivateFieldGet(this, _DragManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE.INTERACTION.DRAG_END, { node: __classPrivateFieldGet(this, _DragManager_node, "f"), matrix: transformationMatrix });
        __classPrivateFieldSet(this, _DragManager_setupOptions, null, "f");
        // optional removal
        // this.removeTransformation(this.#node!);
        this.viewer.updateNode(__classPrivateFieldGet(this, _DragManager_node, "f"));
        this.deactivateNode();
        this.viewer.removeCameraFreezeFlag(__classPrivateFieldGet(this, _DragManager_tokenCameraFreeze, "f"));
        this.viewer.removeContinuousRenderingFlag(__classPrivateFieldGet(this, _DragManager_tokenContinuousRendering, "f"));
        this.viewer.removeShadowMapUpdateFlag(__classPrivateFieldGet(this, _DragManager_tokenContinuousShadowMapUpdate, "f"));
    }
    /**
     * Set the current dragged node.
     * This will serve as the start of the drag event.
     * This function is also called internally at onDown events.
     *
     * @param node
     * @param distance
     * @param intersectionPoint
     * @param ray
     */
    setNode(node, distance = 0, intersectionPoint = gl_matrix_1.vec3.create(), ray = { origin: gl_matrix_1.vec3.create(), direction: gl_matrix_1.vec3.create() }) {
        this.activateNode({ node, distance, point: intersectionPoint });
        __classPrivateFieldSet(this, _DragManager_setupOptions, { viewer: this.viewer, node: __classPrivateFieldGet(this, _DragManager_node, "f"), ray, intersection: __classPrivateFieldGet(this, _DragManager_intersection, "f") }, "f");
        const transformationMatrix = this.dragConstraintUtils.setup(__classPrivateFieldGet(this, _DragManager_dragConstraints, "f"), this.viewer, __classPrivateFieldGet(this, _DragManager_node, "f"), ray, __classPrivateFieldGet(this, _DragManager_intersection, "f"));
        this.applyTransformation(__classPrivateFieldGet(this, _DragManager_node, "f"), transformationMatrix);
        __classPrivateFieldSet(this, _DragManager_tokenCameraFreeze, this.viewer.addCameraFreezeFlag(), "f");
        __classPrivateFieldSet(this, _DragManager_tokenContinuousRendering, this.viewer.addContinuousRenderingFlag(), "f");
        __classPrivateFieldSet(this, _DragManager_tokenContinuousShadowMapUpdate, this.viewer.addShadowMapUpdateFlag(), "f");
        __classPrivateFieldGet(this, _DragManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE.INTERACTION.DRAG_START, { node: __classPrivateFieldGet(this, _DragManager_node, "f"), matrix: transformationMatrix });
    }
    // #endregion Public Methods (7)
    // #region Private Methods (4)
    /**
     * Utility function to make the node the current active node.
     * Set the according values, apply the effect and emit the event.
     *
     * @param intersection
     */
    activateNode(intersection) {
        __classPrivateFieldSet(this, _DragManager_intersection, intersection, "f");
        __classPrivateFieldSet(this, _DragManager_node, __classPrivateFieldGet(this, _DragManager_intersection, "f").node, "f");
        const data = __classPrivateFieldGet(this, _DragManager_node, "f").data.find(d => d instanceof InteractionData_1.InteractionData);
        if (data)
            data.interactionStates['drag'] = true;
        __classPrivateFieldSet(this, _DragManager_effectMaterialToken, this.interactionEffectUtils.applyEffectMaterial(__classPrivateFieldGet(this, _DragManager_node, "f"), this.effectMaterial), "f");
        this.viewer.updateNode(__classPrivateFieldGet(this, _DragManager_node, "f"));
        this.viewer.render();
    }
    /**
     * Utility function to apply the transformation to the current node.
     *
     * @param node
     * @param matrix
     */
    applyTransformation(node, matrix) {
        const index = node.transformations.findIndex(t => t.id === 'SD_drag_matrix');
        if (index !== -1) {
            node.transformations[index].matrix = matrix;
        }
        else {
            node.transformations.push({ id: 'SD_drag_matrix', matrix });
        }
    }
    /**
     * Utility function to make the node inactive.
     * Set the according values, remove the effect and emit the event.
     *
     * @param intersection
     */
    deactivateNode() {
        this.interactionEffectUtils.removeEffectMaterial(__classPrivateFieldGet(this, _DragManager_node, "f"), __classPrivateFieldGet(this, _DragManager_effectMaterialToken, "f"));
        this.viewer.updateNode(__classPrivateFieldGet(this, _DragManager_node, "f"));
        this.viewer.render();
        const data = __classPrivateFieldGet(this, _DragManager_node, "f").data.find(d => d instanceof InteractionData_1.InteractionData);
        if (data)
            data.interactionStates['drag'] = false;
        __classPrivateFieldSet(this, _DragManager_intersection, null, "f");
        __classPrivateFieldSet(this, _DragManager_node, null, "f");
    }
    removeTransformation(node) {
        const index = node.transformations.findIndex(t => t.id === 'SD_drag_matrix');
        if (index !== -1)
            node.transformations.splice(index, 1);
    }
}
exports.DragManager = DragManager;
_DragManager_eventEngine = new WeakMap(), _DragManager_uuidGenerator = new WeakMap(), _DragManager_dragConstraints = new WeakMap(), _DragManager_effectMaterialToken = new WeakMap(), _DragManager_filter = new WeakMap(), _DragManager_intersection = new WeakMap(), _DragManager_node = new WeakMap(), _DragManager_setupOptions = new WeakMap(), _DragManager_tokenCameraFreeze = new WeakMap(), _DragManager_tokenContinuousRendering = new WeakMap(), _DragManager_tokenContinuousShadowMapUpdate = new WeakMap();
//# sourceMappingURL=DragManager.js.map